import React, {
  useCallback,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState,
  forwardRef,
} from "react";

import { PurchaseOrderProvider } from "../../../context/PurchaseOrderContext";
import { SupplierProvider } from "../../../context/SupplierContext";
import { ShipmentResourcesProvider } from "../../Booking/context/Resources";
import { OrderViewTabs } from "./components/Tabs";

interface Props {}

export interface OrderViewHandles {
  open: (OrderId: number) => void;
  close: () => void;
}

const OrderViewComponent: ForwardRefRenderFunction<OrderViewHandles, Props> = (_, ref) => {
  const [isSidebarOpened, setIsSidebarOpened] = useState<boolean>(false);
  const [keyId, setKeyId] = useState<number>();

  const onOpenSidebar = useCallback(
    (dispatchId: number) => {
      // eslint-disable-next-line
      if (keyId != dispatchId) setKeyId(dispatchId);

      setIsSidebarOpened(true);
    },
    [keyId]
  );

  const onCloseSidebar = useCallback(() => {
    setIsSidebarOpened(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open: onOpenSidebar,
    close: onCloseSidebar,
  }));

  return (
    <PurchaseOrderProvider>
      <SupplierProvider>
        <ShipmentResourcesProvider>
          <OrderViewTabs
            keyId={keyId}
            isSidebarOpened={isSidebarOpened}
            onCloseSidebar={onCloseSidebar}
          />
        </ShipmentResourcesProvider>
      </SupplierProvider>
    </PurchaseOrderProvider>
  );
};

export default forwardRef(OrderViewComponent);
